module.exports = __webpack_public_path__ + "img/eszter.23e2a33a.jpg";